/* The homepage's outbound section register, and the nine buttons that link to
   it. v8.

   WHAT CHANGED FROM v7 (16 Oct 2026, Glen). The Flight Deck button is replaced
   by AI (/pages/ai-b2b-gifting), in the same fifth position. Flight Deck stays
   in MOVED, so its homepage section is still hidden; it just has no button in
   this band now. Still nine buttons.

   WHAT CHANGED IN v7. The ROI section moved out. Its key, the opening words of
   its heading, is in MOVED pointing at /pages/roi, and the band got a ninth
   button.

   WHY THE KEY IS A PHRASE AND NOT AN ID. That section carries no id: it is
   <section class="sec" style="padding-top:8px">. findSection falls back to the
   opening words of an h2 or h3, and 'Your ROI, guaranteed' is unique on the
   page. If the heading is ever reworded the key stops matching, the section
   reappears on the homepage, and nothing else breaks - which is the failure
   mode this register was built to have.

   WHAT CHANGED IN v6. The Compliance section stopped being hidden: its panel is
   wanted on the homepage, so 'enterprise' came out of MOVED. The same markup is
   also on /pages/compliance and neither copy knows about the other; edit both.

   WHAT CHANGED IN v5. Playbooks and Rockkt One got pages, taking the band from
   six buttons to eight.

   Rockkt One is NOT in MOVED and must not be, because it was never a section.

   /pages/send-playbooks, not /pages/playbooks: that handle already belongs to
   the guides hub, which is content, not the product.

   WHAT DID NOT CHANGE, AND MUST NOT. MOVED below is still the register that
   SHORTENS the homepage. For every key in it the matching section is set to
   display:none. If you edit this file, the hide loop is the load-bearing part;
   the buttons are just presentation.

   THE BAND IS NOT THE NAV. The header Features menu and the footer Features
   column have their own lists (rockkt-nav-features-*.js, rockkt-footer-sync-*.js);
   changing this band does not change them.

   COPY. No statistic appears in this file. */
(function () {

  /* Sections that now live on their own page.
     Key resolves to a homepage section by id, or by the opening words of its
     first h2/h3. Value is where that section went. */
  var MOVED = {
    'flight-deck':          '/pages/flight-deck',
    'design-studio':        '/pages/design-studio',
    'Every prospect':       '/pages/navigator',
    'Watch every':          '/pages/tracking',
    'intent':               '/pages/tracking',
    'Any gift':             '/pages/gift-lab',
    'hybrid':               '/pages/gift-lab',
    'Prewrite the perfect': '/pages/send-playbooks',
    'Your ROI, guaranteed': '/pages/roi'
  };

  /* The nine buttons: href, sprite symbol, label, one line. */
  var BUTTONS = [
    ['/pages/rockkt-one',      'g-click',        'Rockkt One',    'Send from any LinkedIn profile, without leaving it'],
    ['/pages/send-playbooks',  'g-list',         'Playbooks',     'Prewrite the send, fire it in twenty seconds'],
    ['/pages/gift-lab',        'g-gift',         'Gift Lab',      'Any gift, packed, boxed and posted'],
    ['/pages/design-studio',   'g-sparkles',     'Design Studio', 'Your brand, down to the box on the desk'],
    ['/pages/ai-b2b-gifting',  'g-bulb',         'AI',            'Finds the address, writes the letter, suggests the gift'],
    ['/pages/tracking',        'g-chart',        'Tracking',      'Every send and every signal, in real time'],
    ['/pages/navigator',       'g-compass',      'Navigator',     'Prospects, sequences and next steps'],
    ['/pages/roi',             'g-trending-up',  'ROI',           'Pipeline, closed-won and the guarantee, tracked live'],
    ['/pages/compliance',      'g-shield-check', 'Compliance',    'Caps, approvals and a full audit trail']
  ];

  function findSection(key) {
    var byId = document.getElementById(key);
    if (byId && byId.tagName === 'SECTION') return byId;
    var secs = document.querySelectorAll('section');
    for (var i = 0; i < secs.length; i++) {
      var h = secs[i].querySelector('h2, h3');
      if (h && h.textContent.replace(/\s+/g, ' ').trim().indexOf(key) === 0) return secs[i];
    }
    return null;
  }

  function hideMoved() {
    var n = 0;
    for (var key in MOVED) {
      if (!Object.prototype.hasOwnProperty.call(MOVED, key)) continue;
      var sec = findSection(key);
      if (sec) { sec.style.display = 'none'; n++; }
    }
    return n;
  }

  function anchorNode() {
    return document.getElementById('cta')
        || document.querySelector('section.final')
        || document.querySelector('.rk-ask')
        || document.querySelector('footer');
  }

  function build() {
    hideMoved();

    if (document.querySelector('.rkx6')) return;          /* already built */

    var anchor = anchorNode();
    if (!anchor || !anchor.parentNode) return;

    var tiles = BUTTONS.map(function (b) {
      return '<a class="rkx6-btn" href="' + b[0] + '">' +
               '<span class="rkx6-ic"><svg class="icn" aria-hidden="true"><use href="#' + b[1] + '"/></svg></span>' +
               '<span class="rkx6-txt"><b>' + b[2] + '</b><span>' + b[3] + '</span></span>' +
               '<span class="rkx6-go" aria-hidden="true">' +
                 '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" ' +
                 'stroke-linecap="round" stroke-linejoin="round"><path d="M5 12h13"/><path d="M13 6l6 6-6 6"/></svg>' +
               '</span>' +
             '</a>';
    }).join('');

    var sec = document.createElement('section');
    sec.className = 'rkx6';
    sec.setAttribute('aria-labelledby', 'rkx6Title');
    sec.innerHTML =
      '<div class="wrap">' +
        '<div class="rkx6-inner">' +
          '<div class="rkx6-head">' +
            '<span class="rkx6-eyebrow">Go deeper</span>' +
            '<h2 id="rkx6Title">Nine places to look next</h2>' +
            '<p>Each one is a page of its own, with the whole thing laid out properly.</p>' +
          '</div>' +
          '<nav class="rkx6-grid" aria-label="More about Rockkt">' + tiles + '</nav>' +
        '</div>' +
      '</div>';

    anchor.parentNode.insertBefore(sec, anchor);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', build);
  else build();
})();
